module.exports = "/_next/static/images/pg-4e87aebf78cbb07642b6851b230005c3.svg";